<!-- =========================================================================================
  File Name: FullPage.vue
  Description: Full page layout
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div class="layout--full-page">
    <router-view v-show="!isLoading"></router-view>
  </div>
</template>

<script>
import { mapState } from "vuex";

import api from "@/services/api";

export default {
  data: () => ({
    isLoading: true,
  }),
  async mounted() {
    await this.fetchCompanyWhitelabel();
  },
  computed: {
    ...mapState("company", ["company"]),
  },
  methods: {
    async fetchCompanyWhitelabel() {
      try {
        const { params } = this.$router.history.current;

        if (params.company_label == "anonima") {
          this.isLoading = false;
          this.$store.commit("company/SET_COMPANY", {
            base_hexcolor: "#1e88e5",
            name: "Empresa anônima",
            label: "anonima",
            id: 0,
            logo_url:
              "https://d2xvztw8nmpqec.cloudfront.net/storage/files/logos/GV8fFeSbGUUztAcV5uRHix8vbe1BCzOP1iSbPOaj.png",
            banner_url: null,
            favicon_url: "http://dev-ats-api.recrutei.com.br/favicon.ico",
            has_bot: false,
            has_base_public: false,
            has_ai: false,
            has_indeed: false,
          });
          return;
        }

        this.$vs.loading();

        const response = await api.get(`api/v1/talent/${params.company_label}`);

        const { data } = response.data;

        if (data) {
          this.$store.commit("company/SET_COMPANY", data);
        }

        if (this.company) {
          this.updatePrimaryColor();
          this.$vs.loading.close();
          this.isLoading = false;
        }
      } catch (error) {
        this.$vs.loading.close();
      }
    },
    updatePrimaryColor() {
      if (
        this.company &&
        this.company.hasOwnProperty("base_hexcolor") &&
        this.company.base_hexcolor !== ""
      )
        this.$vs.theme({ primary: (this.company.base_hexcolor !== '#ffffff') ? this.company.base_hexcolor : "#000" });
    },
  },
};
</script>
